(() => {
  if (customElements.get('deferred-featured-collection')) return;

  class DeferredFeaturedCollection extends HTMLElement {
    connectedCallback() {
      this.target = this.querySelector('[data-deferred-featured-collection-target]');
      this.sectionUrl = this.dataset.sectionUrl;

      if (!this.target || !this.sectionUrl) return;

      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      if (this.loading || this.dataset.loaded === 'true') return;
      this.loading = true;
      this.attempts = (this.attempts || 0) + 1;

      try {
        const response = await fetch(this.sectionUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) throw new Error(`Deferred collection request failed: ${response.status}`);

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const renderedProducts = documentFragment.querySelector('[data-deferred-featured-collection-fragment]');

        if (!renderedProducts) throw new Error('Deferred collection response did not contain a product fragment');

        this.target.replaceChildren(...Array.from(renderedProducts.childNodes));
        this.target.removeAttribute('role');
        this.target.removeAttribute('aria-live');
        this.target.removeAttribute('aria-busy');
        this.target.removeAttribute('style');
        this.dataset.loaded = 'true';

        document.dispatchEvent(
          new CustomEvent('luredolls:deferred-collection:loaded', {
            detail: { root: this.target, sectionId: this.dataset.sectionId },
          })
        );
      } catch (error) {
        if (this.attempts < 3) {
          window.setTimeout(() => this.load(), this.attempts * 750);
          return;
        }

        this.target.setAttribute('aria-busy', 'false');
        this.target.removeAttribute('style');
        this.target.replaceChildren();
        const message = document.createElement('p');
        message.className = 'center';
        message.textContent = 'Products could not be loaded. Use the collection link below.';
        this.target.appendChild(message);
        this.dataset.error = 'true';
      } finally {
        this.loading = false;
      }
    }
  }

  customElements.define('deferred-featured-collection', DeferredFeaturedCollection);
})();
